import { MarketplaceConfigUrls } from '@repo/types-client';

const _registry: Record<string, MarketplaceConfigUrls> = {
  mainnet: {
    indexerUrl: 'https://ethereum.sequence.app',
    marketplaceUrl:
      'https://marketplace-api.sequence.app/ethereum/rpc/Marketplace/',
  },
  sepolia: {
    indexerUrl: 'https://sepolia-indexer.sequence.app',
    marketplaceUrl:
      'https://marketplace-api.sequence.app/sepolia/rpc/Marketplace/',
  },
};

const defaultConfig: MarketplaceConfigUrls = {
  indexerUrl: 'https://sepolia-indexer.sequence.app',
  marketplaceUrl:
    'https://marketplace-api.sequence.app/sepolia/rpc/Marketplace/',
};

let _selectedNetwork: MarketplaceConfigUrls = defaultConfig;

switch (process.env.NEXT_PUBLIC_APP_ENV) {
  case 'production':
    _selectedNetwork = _registry.mainnet ?? defaultConfig;
    break;
  default:
    _selectedNetwork = _registry.sepolia ?? defaultConfig;
    break;
}

export const ethereumMarketplaceConfig =
  _selectedNetwork as Readonly<MarketplaceConfigUrls>;
